<div class="title no-print" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'URL生成' | translate }}</h1>
</div>

<div fxLayoutAlign="center start">

  <div class="result">
    <table style="border-collapse:collapse">
      <tr [ngStyle]="{'border-bottom': '3px solid black'}">
        <td class="name">{{'ページ名' | translate }}</td>
        <td class="lang">{{'言語' | translate }}</td>
        <td class="url">{{'URL' | translate }}</td>
      </tr>
      <ng-container *ngFor="let data of qrdata; let i = index">
        <tr [ngStyle]="{'border-bottom': '1px solid #DDDDDD'}">
          <td class="name">
            {{ data.qrcodeType }}&nbsp;:&nbsp;{{ data.name }}
          </td>
          <td class="lang">
            {{ data.lang }}
          </td>
          <td class="url">
            {{ data.siteUrl }}
          </td>
        </tr>
      </ng-container>
    </table>
  </div>
</div>
<div><br><br></div>